import React, { createContext, useContext, useState, useEffect } from "react";
import { DAppConnector, HederaJsonRpcMethod, HederaSessionEvent, HederaChainId } from "@hashgraph/hedera-wallet-connect";
import { LedgerId } from '@hashgraph/sdk'

const projectId:any = process.env.REACT_APP_HASHPACK_PROJECT_ID;

const metadata = {
  name: 'vyga',
  description: 'vyga description',
  url: process.env.REACT_APP_HASHPACK_URL ?? "",
  icons: [process.env.REACT_APP_HASHPACK_ICON_URL ?? ""],
};

// Define the context type
interface WalletContextType {
    dAppConnector: DAppConnector | null;
}

// Create context with the correct type
const WalletContext = createContext<WalletContextType | null>(null);


export const WalletProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [dAppConnector, setDAppConnector] = useState<DAppConnector | null>(null);

    useEffect(() => {
        const initializeWalletConnect = async () => {
            const connector = new DAppConnector(
                metadata,
                LedgerId.TESTNET, 
                projectId,
                Object.values(HederaJsonRpcMethod),
                [HederaSessionEvent.ChainChanged, HederaSessionEvent.AccountsChanged],
                [HederaChainId.Testnet],
            );
            await connector.init({ logger: "error" });
            setDAppConnector(connector);
        };

        initializeWalletConnect();
    }, []);

    return (
        <WalletContext.Provider value={{ dAppConnector }}>
            {children}
        </WalletContext.Provider>
    );
};

// Create a custom hook to use the WalletContext
export const useWallet = (): WalletContextType => {
    const context = useContext(WalletContext);
    if (!context) {
        throw new Error("useWallet must be used within a WalletProvider");
    }
    return context;
};